import React, { useState } from "react";
import { ChromePicker, ColorResult } from "react-color";

type Props = {
	color: string;
	setColor: React.Dispatch<React.SetStateAction<string>>;
}

const ColorPicker = ({color, setColor}: Props) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleChange = (color: ColorResult) => {
    setColor(color.hex);
  };

  return (
	<div className="color-picker-container border border-light">
		<span className="type">HEX</span>
		<input type="text" name="color" id="color" value={color} onChange={e => setColor(e.target.value)}/>
		<span className="trigger" style={{background:color}} onClick={()=>setShowPicker(!showPicker)}></span>

		{showPicker && (
			<div className="color-picker-overlay">
			<ChromePicker color={color} onChange={handleChange} />
			<button className="close-button" onClick={() => setShowPicker(false)}> Close </button>
			</div>
		)}
	</div>
  );
};

export default ColorPicker;
